/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetAllWithdrawalRequestsOptions,
  GetAllWithdrawalRequestsStatus200,
  GetAllWithdrawalRequestsStatus500,
} from '../types/GetAllWithdrawalRequests'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAllWithdrawalRequests } from '../clients/getAllWithdrawalRequests'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAllWithdrawalRequestsQueryKey = ({
  query,
}: Omit<GetAllWithdrawalRequestsOptions, 'headers'> = {}) =>
  [{ url: '/v1/ledger/withdraw/requests' }, ...(query ? [query] : [])] as const

type GetAllWithdrawalRequestsQueryKey = ReturnType<typeof getAllWithdrawalRequestsQueryKey>

export function getAllWithdrawalRequestsQueryOptions(
  { query }: GetAllWithdrawalRequestsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAllWithdrawalRequestsQueryKey({ query })
  return queryOptions<
    GetAllWithdrawalRequestsStatus200,
    ResponseErrorConfig<GetAllWithdrawalRequestsStatus500>,
    GetAllWithdrawalRequestsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAllWithdrawalRequests({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get all withdrawal requests
 * {@link /v1/ledger/withdraw/requests}
 */
export function useGetAllWithdrawalRequests<
  TData = GetAllWithdrawalRequestsStatus200,
  TQueryData = GetAllWithdrawalRequestsStatus200,
  TQueryKey extends QueryKey = GetAllWithdrawalRequestsQueryKey,
>(
  {
    query,
  }: {
    query?:
      | GetAllWithdrawalRequestsOptions['query']
      | (() => GetAllWithdrawalRequestsOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAllWithdrawalRequestsStatus200,
        ResponseErrorConfig<GetAllWithdrawalRequestsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getAllWithdrawalRequestsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getAllWithdrawalRequestsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetAllWithdrawalRequestsStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
